import { api } from "../../../api/apiSlice";

// One Stop report (Batch151) - one master record + a date range, every module's
// transactions that reference it. A single GET returns identity + rows +
// (employee only) the linked user's activity trail, so one Search click is one
// round trip rather than a fan-out across every module's list endpoint. That
// fan-out was the alternative considered and rejected: each module's list is
// paged and branch-scoped independently, so stitching client-side would silently
// truncate exactly where a 360 view matters most - the same reason Batch99 moved
// the Stock Movement Report's customer filter server-side.
export const oneStopApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOneStopReport: builder.query({
      query: (params) => ({ url: "/reports/one-stop", params }),
      providesTags: [{ type: "OneStopReport", id: "CURRENT" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetOneStopReportQuery, useLazyGetOneStopReportQuery } = oneStopApi;
